/* wim-mobile-menu.js
 *
 * Plays the X → lines morph on the mobile-menu drawer close button BEFORE
 * the drawer starts sliding out, so the transition is actually painted.
 *
 * Flow:
 *   1. Capture click on a [data-drawer-close] that contains a wim-icon-menu.
 *   2. Prevent default + stop propagation so the drawer doesn't close yet.
 *   3. Set data-closing="true" → CSS transitions the X back to 3 lines.
 *   4. After ANIM_MS, re-dispatch the click (gated by a pass-through flag)
 *      so the drawer's own handler runs and the drawer slides out.
 *   5. On theme:drawer:open, clear data-closing so the next open re-morphs
 *      the lines back into an X (synced with the drawer slide-in).
 *
 * Scoped narrowly to buttons containing a .wim-icon-menu — cart drawer and
 * any other drawer__close elements are untouched.
 */
(function () {
  'use strict';

  const FLAG = 'data-closing';
  const PASS = 'data-wim-pass';
  const ANIM_MS = 280;

  document.addEventListener(
    'click',
    function (event) {
      const btn = event.target.closest('[data-drawer-close]');
      if (!btn) return;
      if (!btn.querySelector('.wim-icon-menu')) return;
      if (btn.hasAttribute(PASS)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      btn.setAttribute(FLAG, 'true');

      setTimeout(function () {
        btn.setAttribute(PASS, '');
        btn.click();
        btn.removeAttribute(PASS);
      }, ANIM_MS);
    },
    true
  );

  document.addEventListener('theme:drawer:open', function () {
    const buttons = document.querySelectorAll(
      '.drawer__close[' + FLAG + '="true"]'
    );
    buttons.forEach(function (b) {
      b.removeAttribute(FLAG);
    });
  });
})();
